import { MAP_TYPES } from '@deck.gl/carto';

const BROWARDBUSSTOP_SOURCE_ID = 'browardBusStopSource';

const source = {
  id: BROWARDBUSSTOP_SOURCE_ID,
  type: MAP_TYPES.QUERY,
  connection: 'bmpo-smartmetro-09142026',
  data: 'SELECT * FROM `us-con-gcp-npr-0000424-011325.diamond.Broward_Transit_Stops` WHERE Transit_Type = "Bus"',
};

export default source;
